/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import {
  Grid,
  useMediaQuery,
  Box,
  Typography,
  Card,
  CardMedia,
  CardContent,
  CardActions,
} from "@mui/material";
import AddCircularIcon from "../../shared/components/reusableComp/AddCircularIcon";
import { useEffect, useState } from "react";
import { DESKTOP_VIEW_WIDTH } from "../../shared/constants/constants";
import { getFinanceAndLeasingLanding } from "./financeAndLeasingApi";
import IndustryTabView from "../../shared/components/reusableComp/IndustryTabView";
import QuickLinksComp from "../../shared/components/reusableComp/QuickLinksComp";
import { v4 } from "uuid";
import { useNavigate } from "react-router-dom";
const industrycarouselStyle = (matches) => css`
  background: #121212;
  height: 20vw,
  min-height: 20vh;
  padding: ${matches ? "0 40px" : "30px 0"};
`;

const quickContainerCss = (matches) => css`
  display: flex;
  justify-content: space-around;
  padding-top: 20px;
  margin-bottom: 40px;
  display: flex;
  justify-content: ${matches ? "center" : "space-evenly"};
  align-items: center;
`;
const financeWrapper = (matchMobile) => css`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: ${matchMobile ? 0 : "40px"} ${matchMobile ? 0 : "120px"};
  flex-wrap: wrap;
`;
const bannerWrapper = (matchMobile) => css`
  width: 100%;
  img {
    width: 100%;
    vertical-align: bottom;
  }
  position: relative;
  .MuiTypography-body1 {
    position: absolute;
    top: 30px;
    left: ${matchMobile ? "36px" : "80px"};
  }
`;
const cardWrapper = (matchMobile) => css`
  background: #121212;
  margin-bottom: 20px;
  border: none;
  box-shadow: none;
  .MuiCardContent-root {
    padding-left: ${matchMobile ? "16px" : 0};
    background: #121212;
    .MuiTypography-root {
      color: white;
    }
  }
  video {
    width: 100%;
  }
  .MuiCardActions-root {
    padding-left: ${matchMobile ? "16px" : 0};
  }
`;
const descriptionWrapper = (theme) => css`
  font-size: 14px;
  line-height: 35px;
  font-family: ${theme.typography.MBCORPOA};
`;
const financeButton = css`
  height: 50px;
  .MuiBox-root {
    margin: 0;
  }
`;
const renderCardItem = (financeItem, matchMobile, navigate) => {
  return (
    <Card
      sx={{ width: matchMobile ? "100%" : "48%" }}
      css={() => cardWrapper(matchMobile)}
      key={v4()}
    >
      <CardMedia
        component="img"
        image={`${process.env.REACT_APP_BASEURL}${financeItem?.img?.data?.attributes?.url}`}
        alt={`${process.env.REACT_APP_BASEURL}${financeItem?.img?.data?.attributes?.url}`}
      />
      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
          {financeItem?.title}
        </Typography>
        <Typography
          css={descriptionWrapper}
          variant="body2"
          color="text.secondary"
        >
          {financeItem?.description}
        </Typography>
      </CardContent>
      <CardActions css={financeButton}>
        <AddCircularIcon
          handleClick={() =>
            navigate(`/finance-leasing-detail${financeItem?.buttonLink}`)
          }
          buttonText={financeItem?.buttonText}
        />
      </CardActions>
    </Card>
  );
};
function FinanceAndLeasing() {
  const [quickLinksData, setQuickLinksData] = useState([]);
  const [industryTabData, setIndustryTabData] = useState([]);
  const [financeData, setFinanceData] = useState([]);
  const [bannerData, setBannerData] = useState(null);
  const matches = useMediaQuery(DESKTOP_VIEW_WIDTH);
  const matchMobile = useMediaQuery("(max-width: 415px)");
  const navigate = useNavigate();

  useEffect(() => {
    getFinanceAndLeasingLanding().then(({ data }) => {
      document.title = data?.data?.attributes?.title;
      data?.data?.attributes?.body?.map((item) => {
        if (item.__component === "components.list") {
          setQuickLinksData([...item.ctaList]);
        } else if (item.__component === "components.industry-tabs") {
          setIndustryTabData([...item.industryTab]);
        } else if (item.__component === "shared.description-image-banner") {
          setBannerData(item);
        } else if (item.__component === "components.finance-block") {
          setFinanceData([...item.FinanceItem]);
        }
      });
    });
  }, []);

  return (
    <div className="App" style={{ zIndex: "-1", marginTop: "" }}>
      <Grid container style={{ background: "#121212" }}>
        <Box css={() => bannerWrapper(matchMobile)}>
          <img
            src={`${process.env.REACT_APP_BASEURL}${bannerData?.image?.data?.attributes?.url}`}
            alt={`${process.env.REACT_APP_BASEURL}${bannerData?.image?.data?.attributes?.name}`}
          />
          <Typography component="div">
            <Typography variant="h5">{bannerData?.title}</Typography>
            <Typography css={descriptionWrapper} variant="body2">
              {bannerData?.description}
            </Typography>
          </Typography>
        </Box>
        <Box css={() => financeWrapper(matchMobile)}>
          {financeData.map((financeItem) =>
            renderCardItem(financeItem, matchMobile, navigate)
          )}
        </Box>
        {industryTabData.length > 0 && (
          <Grid item css={() => industrycarouselStyle(matches)} xs={12}>
            <IndustryTabView
              industryTabData={industryTabData}
              isFromFinance={true}
            />
          </Grid>
        )}

        {quickLinksData.length >= 0 && (
          <Grid item css={() => quickContainerCss(!matchMobile)} xs={12}>
            <QuickLinksComp quickLinksData={quickLinksData} />
          </Grid>
        )}
      </Grid>
    </div>
  );
}

export default FinanceAndLeasing;
